import type { SurveyGroup, RiskZone } from '@/types'

export interface ActionPoint {
  id: string
  zone: RiskZone['id']
  dimension: 'trusty' | 'sincerity' | 'care' | 'competence' | 'reliability'
  topic: Topic['id']
  priority: number
  texts: {
    de: ActionPointText
    en: ActionPointText
  }
  surveyGroupType: SurveyGroup.EMPLOYEE | SurveyGroup.PARTNER | SurveyGroup.CUSTOMER
}

export interface ActionPointText {
  text: string
  details: ActionPointDetails | undefined
  problemIndicators: string[]
  solutionIndicators: string[]
}

export interface ActionPointDetails {
  description1: string
  description2: string
  points: string[]
}

export type Topic = {
  id: ActionPointTopic
}

export enum ActionPointTopic {
  acknowledgement = 'acknowledgement',
  capacity = 'capacity',
  celebrating = 'celebrating',
  collaboration = 'collaboration',
  communication = 'communication',
  competence = 'competence',
  connection = 'connection',
  credibility = 'credibility',
  decisionmaking = 'decisionmaking',
  failures = 'failures',
  feedback = 'feedback',
  growth_mindset = 'growth_mindset',
  information = 'information',
  leadership = 'leadership',
  meetings = 'meetings',
  objectives = 'objectives',
  people_dev = 'people_dev',
  psychological_safety = 'psychological_safety',
  resilience = 'resilience',
  responsibilty = 'responsibilty',
  roles = 'roles',
  rules = 'rules',
  salary = 'salary',
  standards = 'standards',
  workroutine = 'workroutine',
}
